export default {
  category_name: 'Comprar cartão de oferta',
};
